// Component bảng ma trận đề kiểm tra

import React from 'react'
import { ExamMatrixRow } from '../../types/exam-matrix'
import { MatrixRowGroup } from './MatrixRowGroup'
import { calculateMatrixTotalScore, calculateColumnSum, countTotalQuestions } from '../../utils/exam-matrix-calculator'

interface ExamMatrixTableProps {
  rows: ExamMatrixRow[]
  onUpdateRow: (rowId: string, updates: Partial<ExamMatrixRow>) => void
  onDeleteRow: (rowId: string) => void
  onDeleteDang: (rowId: string, dangIndex: number) => void
}

export const ExamMatrixTable: React.FC<ExamMatrixTableProps> = ({
  rows,
  onUpdateRow,
  onDeleteRow,
  onDeleteDang
}) => {
  const totalScore = calculateMatrixTotalScore(rows)
  const totalQuestions = countTotalQuestions(rows)

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse bg-white shadow-lg rounded-lg overflow-hidden">
        <thead>
          {/* Header Row 1 */}
          <tr className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white">
            <th rowSpan={3} className="border border-white px-3 py-3 text-sm font-semibold">TT</th>
            <th rowSpan={3} className="border border-white px-3 py-3 text-sm font-semibold">Chủ đề/<br />Chương</th>
            <th rowSpan={3} className="border border-white px-3 py-3 text-sm font-semibold">Bài/<br />Nội dung</th>
            <th rowSpan={3} className="border border-white px-3 py-3 text-sm font-semibold">Yêu cầu cần đạt/<br />Dạng</th>
            <th colSpan={12} className="border border-white px-3 py-3 text-sm font-semibold">
              Số câu hỏi ở các mức độ đánh giá
            </th>
            <th colSpan={2} className="border border-white px-3 py-3 text-sm font-semibold">Tổng</th>
          </tr>

          {/* Header Row 2 - Loại câu hỏi */}
          <tr className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
            <th colSpan={9} className="border border-white px-3 py-2 text-sm font-semibold">TNKQ</th>
            <th colSpan={3} className="border border-white px-3 py-2 text-sm font-semibold">Tự luận</th>
            <th rowSpan={2} className="border border-white px-3 py-2 text-xs font-semibold">Số CH</th>
            <th rowSpan={2} className="border border-white px-3 py-2 text-xs font-semibold">% Điểm</th>
          </tr>

          {/* Header Row 3 - Chi tiết loại */}
          <tr className="bg-gradient-to-r from-blue-400 to-indigo-400 text-white">
            <th colSpan={3} className="border border-white px-2 py-2 text-xs font-semibold">
              Nhiều lựa chọn<br />
              <span className="text-xs font-normal">(0.25đ/câu)</span>
            </th>
            <th colSpan={3} className="border border-white px-2 py-2 text-xs font-semibold">
              Đúng - Sai<br />
              <span className="text-xs font-normal">(1đ/câu)</span>
            </th>
            <th colSpan={3} className="border border-white px-2 py-2 text-xs font-semibold">
              Trả lời ngắn<br />
              <span className="text-xs font-normal">(0.5đ/câu)</span>
            </th>
            <th colSpan={3} className="border border-white px-2 py-2 text-xs font-semibold">
              Tự luận<br />
              <span className="text-xs font-normal">(1.0đ/câu)</span>
            </th>
          </tr>

          {/* Header Row 4 - Mức độ */}
          <tr className="bg-gradient-to-r from-blue-300 to-indigo-300 text-gray-800">
            <th className="border px-2 py-2 text-xs font-semibold">Biết</th>
            <th className="border px-2 py-2 text-xs font-semibold">Hiểu</th>
            <th className="border px-2 py-2 text-xs font-semibold">Vận dụng</th>

            <th className="border px-2 py-2 text-xs font-semibold">Biết</th>
            <th className="border px-2 py-2 text-xs font-semibold">Hiểu</th>
            <th className="border px-2 py-2 text-xs font-semibold">Vận dụng</th>

            <th className="border px-2 py-2 text-xs font-semibold">Biết</th>
            <th className="border px-2 py-2 text-xs font-semibold">Hiểu</th>
            <th className="border px-2 py-2 text-xs font-semibold">Vận dụng</th>

            <th className="border px-2 py-2 text-xs font-semibold">Biết</th>
            <th className="border px-2 py-2 text-xs font-semibold">Hiểu</th>
            <th className="border px-2 py-2 text-xs font-semibold">Vận dụng</th>

            <th className="border px-2 py-2 text-xs font-semibold">Số CH</th>
            <th className="border px-2 py-2 text-xs font-semibold">% Điểm</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, rowIndex) => (
            <MatrixRowGroup
              key={row.id}
              row={row}
              rowIndex={rowIndex}
              totalMatrixScore={totalScore}
              onUpdate={onUpdateRow}
              onDelete={onDeleteRow}
              onDeleteDang={onDeleteDang}
            />
          ))}

          {/* Dòng TỔNG */}
          <tr className="bg-gradient-to-r from-indigo-100 to-blue-100 font-bold">
            <td colSpan={4} className="text-center border px-3 py-3 text-lg">TỔNG</td>

            {/* TNKQ - Nhiều lựa chọn */}
            <td className="text-center border px-2 py-2 bg-blue-50">{calculateColumnSum(rows, 'tnkq.nhieuLuaChon.biet')}</td>
            <td className="text-center border px-2 py-2 bg-blue-50">{calculateColumnSum(rows, 'tnkq.nhieuLuaChon.hieu')}</td>
            <td className="text-center border px-2 py-2 bg-blue-50">{calculateColumnSum(rows, 'tnkq.nhieuLuaChon.vanDung')}</td>

            {/* TNKQ - Đúng Sai */}
            <td className="text-center border px-2 py-2 bg-green-50">{calculateColumnSum(rows, 'tnkq.dungSai.biet')}</td>
            <td className="text-center border px-2 py-2 bg-green-50">{calculateColumnSum(rows, 'tnkq.dungSai.hieu')}</td>
            <td className="text-center border px-2 py-2 bg-green-50">{calculateColumnSum(rows, 'tnkq.dungSai.vanDung')}</td>

            {/* TNKQ - Trả lời ngắn */}
            <td className="text-center border px-2 py-2 bg-yellow-50">{calculateColumnSum(rows, 'tnkq.traLoiNgan.biet')}</td>
            <td className="text-center border px-2 py-2 bg-yellow-50">{calculateColumnSum(rows, 'tnkq.traLoiNgan.hieu')}</td>
            <td className="text-center border px-2 py-2 bg-yellow-50">{calculateColumnSum(rows, 'tnkq.traLoiNgan.vanDung')}</td>

            {/* Tự luận */}
            <td className="text-center border px-2 py-2 bg-purple-50">{calculateColumnSum(rows, 'tuLuan.biet')}</td>
            <td className="text-center border px-2 py-2 bg-purple-50">{calculateColumnSum(rows, 'tuLuan.hieu')}</td>
            <td className="text-center border px-2 py-2 bg-purple-50">{calculateColumnSum(rows, 'tuLuan.vanDung')}</td>

            {/* Tổng */}
            <td className="text-center border px-2 py-2 bg-indigo-100 text-lg">{totalQuestions}</td>
            <td className="text-center border px-2 py-2 bg-indigo-100 text-lg">100%</td>
          </tr>

          {/* Dòng hiển thị tổng điểm */}
          <tr className="bg-gradient-to-r from-green-100 to-emerald-100">
            <td colSpan={14} className="text-right border px-4 py-2 font-semibold text-gray-700">
              Tổng điểm:
            </td>
            <td colSpan={2} className="text-center border px-4 py-2 font-bold text-xl text-green-700">
              {totalScore.toFixed(2)} điểm
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

